<template>
  <div class="animated fadeIn">
    <div id="accueil-eb">
      <b-card>
        <b-row>
          <b-col md="12">
            <h1 class="display-3">Gestion des Produits</h1>
          </b-col>
        </b-row>
        <b-row class="">
          <b-col md="6">
            <b-row v-if="allFamilleProduit">
              <table class="famille_produit">
                <thead>
                  <tr>
                    <th>Gamme</th>
                    <th class="th-famille">Famille</th>
                    <th>Grille de salaire</th>
                  </tr>
                </thead>
                <component :is="dynamicComponent" />
              </table>

            </b-row>
            <b-row v-else>
              <p>Aucune Famille de produit trouvée.</p>
            </b-row>
          </b-col>
          <b-col md="6">
            <div v-if="produitsToConfigure.length > 0">
              <b-card no-body>
                <b-card-header>
                  <i class="fa fa-list mr-2"></i>
                  <strong>Liste des codes produits devant être qualifiés</strong>
                </b-card-header>
                <b-card-body>
                  <b-list-group class="">
                    <b-list-group-item v-for="produit in produitsToConfigure" :key="produit.id" :active="produitId === produit.id">
                      {{ produit.code_produit }}
                      <span class="pull-right" v-if="canManageFamille()" v-b-toggle.collapse-produit><i class="icon fa fa-pencil mr-2" @click="manageProduit(produit,this)"></i></span>
                    </b-list-group-item>
                  </b-list-group>
                </b-card-body>
                <b-collapse id="collapse-produit" class="mt-2">
                  <b-card-body>
                    <b-form-group id="fieldset-description" label="Description du produit *" label-for="description">
                      <b-form-input id="description" v-model="description" :class="{hasError: errors.description !== ''}" trim placeholder="Ex. : Accord FR"></b-form-input>
                      <span class='field-error'>{{ errors.description }}</span>
                    </b-form-group>
                    <b-form-group id="fieldset-precision" label="Précision sur le produit" label-for="precision">
                      <b-form-input id="precision" v-model="precision" :class="{hasError: errors.precision !== ''}" trim placeholder="Ex. : Option Prémensu."></b-form-input>
                      <span class='field-error'>{{ errors.precision }}</span>
                    </b-form-group>
                    <b-form-group id="fieldset-famille" label="Famille du produit *" label-for="familleCodeProduitId">
                      <b-form-select v-model="familleCodeProduitId" :options="allFamilleProduitOption"  :class="{hasError: errors.familleCodeProduitId !== ''}">
                        <template v-slot:first>
                          <b-form-select-option value="">-- Sélectionnez une Famille --</b-form-select-option>
                        </template>
                      </b-form-select>
                      <span class='field-error'>{{ errors.familleCodeProduitId }}</span>
                    </b-form-group>
                    <b-form-group id="fieldset-type" label="Type de produit *" label-for="type">
                      <b-form-select v-model="type" :options="allTypeOption"  :class="{hasError: errors.type !== ''}">
                        <template v-slot:first>
                          <b-form-select-option value="">-- Sélectionnez un type --</b-form-select-option>
                        </template>
                      </b-form-select>
                      <span class='field-error'>{{ errors.type }}</span>
                    </b-form-group>
                    <b-form-group id="fieldset-onSale" label="Le produit est-il toujours disponible à la vente *" label-for="radio-group-onSale">
                      <b-form-radio-group id="radio-group-onSale" v-model="onSale" name="radio-sub-component">
                        <b-form-radio value="oui">Oui</b-form-radio>
                        <b-form-radio value="non">Non</b-form-radio>
                      </b-form-radio-group>
                      <span class='field-error'>{{ errors.onSale }}</span>
                    </b-form-group>
                    <div class="mt-2">
                      <b-button type="button" @click.prevent="clearFormProduit()" size="md" variant="secondary" class="mr-2 mt-2" v-b-toggle.collapse-produit>
                        Annuler
                      </b-button>
                      <b-button size="md" variant="primary" @click="saveProduit()" class="mr-2 mt-2"><i class="fa fa-save"></i> Enregistrer</b-button>
                    </div>
                  </b-card-body>
                </b-collapse>
              </b-card>
            </div>
            <b-modal size="xl" centered
              title="Modifier la famille de produit"
              id="modal-modify"
              ref="modal-modify"
              @close="clearFormFamille()"
              v-model="modify">
              <b-card no-body>
                <b-card-body>
                  <b-form-group id="fieldset-1" label="Libellé de la famille produit" label-for="libelle">
                    <b-form-input id="libelle" v-model="libelle" :class="{hasError: errors.libelle !== ''}" trim></b-form-input>
                    <span class='field-error'>{{ errors.libelle }}</span>
                  </b-form-group>
                  <div class="list-produit">
                    <b-badge pill v-for="produit in produits" :key="produit.id" variant="warning" class="mr-1">{{ produit.code_produit }} ( {{ produit.type.libelle_court }} )</b-badge>
                  </div>
                </b-card-body>
              </b-card>
              <template v-slot:modal-footer>
                <div class="w-100">
                  <b-button size="md" variant="primary" class="float-right" @click="save()"><i class="fa fa-save"></i> Modifier</b-button>
                  <b-button size="md" variant="secondary" class="mr-2 float-right" @click="clearFormFamille()">fermer</b-button>
                </div>
              </template>
            </b-modal>
            <b-modal size="xl" centered
              :title="`Modifier le produit : ${codeToModify}`"
              id="modal-modify-produit"
              ref="modal-modify-produit"
              @close="clearFormProduit()"
              >
              <b-card-text>
                Si vous changer le code produit de famille, cette opération peut être longue car il faut modifier toutes les données rattaché à ce code produit (SIREN, Affiliation...).
              </b-card-text>
              <b-card-body>
                <b-form-group id="fieldset-description" label="Description du produit *" label-for="description">
                  <b-form-input id="description" v-model="description" :class="{hasError: errors.description !== ''}" trim placeholder="Ex. : Accord FR"></b-form-input>
                  <span class='field-error'>{{ errors.description }}</span>
                </b-form-group>
                <b-form-group id="fieldset-precision" label="Précision sur le produit" label-for="precision">
                  <b-form-input id="precision" v-model="precision" :class="{hasError: errors.precision !== ''}" trim placeholder="Ex. : Option Prémensu."></b-form-input>
                  <span class='field-error'>{{ errors.precision }}</span>
                </b-form-group>
                <b-form-group id="fieldset-famille" label="Famille du produit *" label-for="familleCodeProduitId">
                  <b-form-select v-model="familleCodeProduitId" :options="allFamilleProduitOption"  :class="{hasError: errors.familleCodeProduitId !== ''}">
                    <template v-slot:first>
                      <b-form-select-option value="">-- Sélectionnez une Famille --</b-form-select-option>
                    </template>
                  </b-form-select>
                  <span class='field-error'>{{ errors.familleCodeProduitId }}</span>
                </b-form-group>
                <b-form-group id="fieldset-type" label="Type de produit *" label-for="type">
                  <b-form-select v-model="type" :options="allTypeOption"  :class="{hasError: errors.type !== ''}">
                    <template v-slot:first>
                      <b-form-select-option value="">-- Sélectionnez un type --</b-form-select-option>
                    </template>
                  </b-form-select>
                  <span class='field-error'>{{ errors.type }}</span>
                </b-form-group>
                <b-form-group id="fieldset-onSale" label="Le produit est-il toujours disponible à la vente *" label-for="radio-group-onSale">
                  <b-form-radio-group id="radio-group-onSale" v-model="onSale" name="radio-sub-component">
                    <b-form-radio value="oui">Oui</b-form-radio>
                    <b-form-radio value="non">Non</b-form-radio>
                  </b-form-radio-group>
                  <!-- valeur de onSale : {{ onSale }} ({{ typeof onSale }}) -->
                  <span class='field-error'>{{ errors.onSale }}</span>
                </b-form-group>
                <!-- <div class="mt-2">
                  <b-button type="button" @click.prevent="clearFormProduit()" size="md" variant="secondary" class="mr-2 mt-2" v-b-toggle.collapse-produit>
                    Annuler
                  </b-button>
                  <b-button size="md" variant="primary" @click="saveProduit()" class="mr-2 mt-2"><i class="fa fa-save"></i> Enregistrer</b-button>
                </div> -->
              </b-card-body>
              <template v-slot:modal-footer>
                <div class="w-100">
                  <b-button size="md" variant="primary" @click="saveProduit()" class="mr-2 mt-2 float-right"><i class="fa fa-save"></i> Enregistrer</b-button>
                  <b-button type="button" @click.prevent="clearFormProduit()" size="md" variant="secondary" class="mr-2 mt-2 float-right">
                    Annuler
                  </b-button>
                </div>
              </template>
            </b-modal>
          </b-col>
        </b-row>
      </b-card>
    </div>
  </div>
</template>

<script>
import { getBaseUrl, getProvider, getIdToken, getAccessToken } from '@/utils/auth';
import { hasRule, espaceGestionRules as rules } from '@/utils/rulesHelper';
import {isEmpty} from "@/utils/fileHelper";

// A la place du table
// <b-list-group class="with-index">
//                 <b-list-group-item v-for="famille in allFamilleProduit" :key="famille.id">
//                   <span class="index">{{ famille.gamme.libelle }}</span>
//                   <span class="body">{{ famille.libelle }}</span>
//                   <span class="lh align-middle pull-right">
//                     <b-button size="sm" :id="'button-'+famille.id" variant="outline-success" class="mr-1">codes produits</b-button>
//                     <b-tooltip :target="'button-'+famille.id" placement="right">
//                       <b-badge pill v-for="produit in famille.produits" :key="produit.id" variant="info" class="mr-1">{{ produit.code_produit }}</b-badge>
//                     </b-tooltip>
//                   </span>
//                   <span class="lh pull-right align-middle" v-if="canManageFamille()"><i class="icon fa fa-pencil mr-2" @click="edit(famille)"></i></span>
//                 </b-list-group-item>
//               </b-list-group>

export default {
  data() {
    return {
      allFamilleProduit: [],
      allFamilleGammeGrouped: [],
      modify: false,
      familleId: '',
      libelle: '',
      produits: [],
      description: '',
      precision: '',
      type: '',
      onSale: '',
      produitId: '',
      familleCodeProduitId: '',
      allType: [],
      allTypeOption: [],
      allFamilleProduitOption: [],
      produitsToConfigure: [],
      codeToModify: '',
      errors: {
        libelle: '',
        description: '',
        precision: '',
        familleCodeProduitId: '',
        type: '',
        onSale: '',
      }
    }
  },
  computed: {
    dynamicComponent: function() {
      let response = '';

      // console.log('allFamilleProduit', this.allFamilleProduit)

      if (this.allFamilleGammeGrouped[1] !== undefined) {
        for (let index in this.allFamilleGammeGrouped) {

          let groupe = [...this.allFamilleGammeGrouped[index]]
          let nbLine = groupe.length
          let firstLine = groupe.shift();
          let hasTaux = '';
          if (!isEmpty(firstLine.grille_salaire)) {
            hasTaux = `<span> / <b>TC</b> :` + firstLine.grille_salaire.has_grille_salaire_taux === true ? 'Oui' : 'Non'
          }

          // console.log('firstLine',firstLine)
          response = response + `<tr>
              <td rowspan="${nbLine}" class="td-gamme">${firstLine.gamme.libelle} ( ${firstLine.gamme.secteur.toUpperCase().replaceAll(',', ' | ')} )</td>
              <td><span id="'famille-tooltip'-${firstLine.id}">${firstLine.libelle.substring(0, 30)}</span>
                <b-tooltip target="'famille-tooltip'-${firstLine.id}" triggers="hover" placement="top">${firstLine.libelle}</b-tooltip>
                <span class="align-middle pull-right">
                    <b-button size="sm" id="button-${firstLine.id}" variant="outline-success" class="mr-1">codes produits</b-button>
                    <b-tooltip target="button-${firstLine.id}" placement="right">`;
          for (let produit of firstLine.produits) {
            response = response + `<b-badge pill variant="info" class="clickable mr-1" @click="modifyProduit(${produit.id},${firstLine.id})">${ produit.code_produit }</b-badge>`;
          }

          response = response +  `</b-tooltip>
                  </span>
                  <span v-b-modal.modal-modify class="pull-right align-middle clickable" v-if="canManageFamille()" title="Changer le libellé"><i class="icon fa fa-pencil mr-2" @click="edit(`+ firstLine.id +`)"></i></span></td>
                  <td>${ !isEmpty(firstLine.grille_salaire) ? firstLine.grille_salaire.libelle : ''}</td>
                </tr>`;
          for (let famille of groupe) {
            let hasTaux = '';
            if (!isEmpty(famille.grille_salaire)) {
              hasTaux = `<span> / <b>TC</b> :` + famille.grille_salaire.has_grille_salaire_taux === true ? 'Oui' : 'Non'
            }
            response = response + `<tr>
              <td><span id="'famille-tooltip'-${famille.id}">${famille.libelle.substring(0, 30)}</span>
                  <b-tooltip target="'famille-tooltip'-${famille.id}" triggers="hover" placement="top">${famille.libelle}</b-tooltip>
                  <span class="align-middle pull-right">
                    <b-button size="sm" id="button-${famille.id}" variant="outline-success" class="mr-1">codes produits</b-button>
                    <b-tooltip target="button-${famille.id}" placement="right">`;
            for (let produit of famille.produits) {
              response = response + `<b-badge pill variant="info" class="clickable mr-1" @click="modifyProduit(${produit.id},${famille.id})">${ produit.code_produit }</b-badge>`;
            }

            response = response +  `</b-tooltip>
                  </span>
                  <span class="pull-right align-middle clickable" v-if="canManageFamille()" title="Changer le libellé"><i class="icon fa fa-pencil mr-2" @click="edit(`+ famille.id + `)"></i></span></td>
                  <td>${ !isEmpty(famille.grille_salaire) ? famille.grille_salaire.libelle : '' }</span></td>
                </tr>`;
          }
        }
      }
      // console.log(response)
      return {
        template: '<tbody>' + response + '</tbody>',
        methods: {
          canManageFamille() {
            return hasRule(rules.CAN_MANAGE_PRODUIT)
          },
          edit(familleId) {
            for (let famille of this.$parent.allFamilleProduit) {
              if (famille.id === familleId) {
                this.$parent.modify = true
                this.$parent.familleId = famille.id
                this.$parent.libelle = famille.libelle
                this.$parent.produits = famille.produits
              }
            }
          },
          modifyProduit(produitId, familleId) {
            // console.log(produitId,familleId)
            let familleProduit = this.$parent.allFamilleProduit.find(famille => famille.id === familleId);
            let produitToModify = familleProduit.produits.find(produit => produit.id === produitId);
            // console.log('produitToModify',produitToModify)
            this.$parent.familleCodeProduitId = produitToModify.famille_id;
            this.$parent.description = produitToModify.description;
            this.$parent.precision = produitToModify.precision;
            this.$parent.type = produitToModify.type_id;
            this.$parent.onSale = !isEmpty(produitToModify.vente) && produitToModify.vente ? 'oui' : (!isEmpty(produitToModify.vente) ? 'non' : '');
            this.$parent.codeToModify = produitToModify.code_produit;
            this.$parent.produitId = produitToModify.id;
            this.$parent.$refs['modal-modify-produit'].show();
            // console.log('this.$parent.onSale',this.$parent.onSale)
          },
        }
      }
    }
  },
  mounted() {

    this.getProduitsToConfigure()
    this.getTypeProduit()
  },
  async created() {
    this.$axios.defaults.baseURL = getBaseUrl();
    this.$axios.defaults.headers.common['Authorization'] = getIdToken() + ' ' + getAccessToken()
    this.$axios.defaults.headers.common['Accept'] = 'application/json';
    this.$axios.defaults.headers.common['Provider'] = getProvider();
    await this.getFamilleProduit()
  },
  methods: {
    getFamilleProduit() {
      let self = this
      this.$store.commit('IS_LOADING', true)
      this.$axios
        .get('/espaceGestion/famille-produit/all')
        .then(response => {
          this.$store.commit("IS_LOADING", false)
          this.allFamilleProduit = response.data.familles
          this.allFamilleProduitOption = response.data.familles.map( famille => {return {value: famille.id, text: famille.libelle}})
          this.allFamilleGammeGrouped = _.groupBy(this.allFamilleProduit, 'gamme_id')
          // console.log(this.allFamilleGammeGrouped)
        })
        .catch(function(error) {
          console.log(error)
          self.$store.commit('IS_LOADING', false)
          self.$swal({
            position: 'top',
            type: 'error',
            title: 'Attention !!',
            text: 'Une erreur est survenue, si le problème persiste merci de contacter faire un ticket au support DOSI',
            showConfirmButton: false,
            timer: 5000
          })
        })
    },
    getProduitsToConfigure() {
      let self = this
      this.$store.commit('IS_LOADING', true)
      this.$axios
        .get('/espaceGestion/famille-produit/get-produit-to-configure')
        .then(response => {
          this.$store.commit("IS_LOADING", false)
          this.produitsToConfigure = response.data.produits
        })
        .catch(function(error) {
          console.log(error)
          self.$store.commit('IS_LOADING', false)
          self.$swal({
            position: 'top',
            type: 'error',
            title: 'Attention !!',
            text: 'Une erreur est survenue, si le problème persiste merci de contacter faire un ticket au support DOSI',
            showConfirmButton: false,
            timer: 5000
          })
        })
    },
    getTypeProduit() {
      let self = this
      this.$store.commit('IS_LOADING', true)
      this.$axios
        .get('/espaceGestion/famille-produit/get-type-produit')
        .then(response => {
          this.$store.commit("IS_LOADING", false)
          this.allType = response.data.types
          this.allTypeOption = response.data.types.map( type => {return {value: type.id, text: type.libelle_court}})
        })
        .catch(function(error) {
          console.log(error)
          self.$store.commit('IS_LOADING', false)
          self.$swal({
            position: 'top',
            type: 'error',
            title: 'Attention !!',
            text: 'Une erreur est survenue, si le problème persiste merci de contacter faire un ticket au support DOSI',
            showConfirmButton: false,
            timer: 5000
          })
        })
    },
    canManageFamille() {
      return hasRule(rules.CAN_MANAGE_PRODUIT)
    },
    edit(famille) {
      // console.log(famille)
      this.modify = true
      this.familleId = famille.id
      this.libelle = famille.libelle
      this.produits = famille.produits
    },
    validateFormFamille() {
      let valid = true

      if (this.libelle === '') {
        this.errors.libelle = 'Le libelle est obligatoire'
        valid = false;
      }

      return valid
    },
    clearFormFamille() {
      this.modify = false
      this.familleId = ''
      this.libelle = ''
      this.produits = []
      this.errors.libelle = ''
    },
    save() {
      if (this.validateFormFamille()) {
        let self = this;
        let dataPost = {
          'libelle': this.libelle,
        }
        this.$store.commit('IS_LOADING', true)
        this.$axios
          .post('/espaceGestion/famille-produit/update/'+this.familleId, dataPost)
          .then(response => {
            this.$store.commit('IS_LOADING', false)
            self.$swal({
              position: 'top',
              type: 'success',
              title: 'Modification avec succès',
              text: 'La modification a bien été apportée',
              showConfirmButton: false,
              timer: 3000
            })
            this.clearFormFamille()
            this.getFamilleProduit()
          })
          .catch(function(error) {
            self.$store.commit('IS_LOADING', false)
            self.$swal({
              position: 'top',
              type: 'error',
              title: 'Attention !!',
              text: 'Une erreur est survenue lors de l\'enregistrement du produit, si le problème persiste merci de faire un ticket au support DOSI',
              showConfirmButton: false,
              timer: 5000
            })
          })
      }
    },
    validateFormProduit() {
      let valid = true

      if (this.description === '') {
        this.errors.description = 'La description est obligatoire'
        valid = false;
      }

      if (this.familleCodeProduitId === '') {
        this.errors.familleCodeProduitId = 'La famille de produit est obligatoire'
        valid = false;
      }

      if (this.type === '') {
        this.errors.type = 'La type de produit est obligatoire'
        valid = false;
      }

      if (this.onSale === '') {
        this.errors.type = 'La disponibilité du produit à la vente est obligatoire'
        valid = false;
      }

      return valid
    },
    clearFormProduit() {
      this.produitId = ''
      this.description = ''
      this.precision = ''
      this.type = ''
      this.onSale = ''
      this.familleCodeProduitId = ''
      this.errors.description = ''
      this.errors.type = ''
      this.errors.familleCodeProduitId = ''
      this.errors.onSale = ''
      this.$bvModal.hide('modal-modify-produit');
    },
    manageProduit(produit) {
      // console.log(this.allFamilleProduitOption)
      this.produitId = produit.id
      this.description = produit.description
      this.precision = produit.precision
      this.type = produit.type_id
      this.onSale = produit.vente
    },
    saveProduit() {
      if (this.validateFormProduit()) {
        let self = this;
        let dataPost = {
          'description': this.description,
          'precision': this.precision,
          'type': this.type,
          'familleId': this.familleCodeProduitId,
          'onSale': this.onSale,
        }
        this.$store.commit('IS_LOADING', true)
        this.$axios
          .post('/espaceGestion/famille-produit/attach/'+this.produitId, dataPost)
          .then(response => {
            this.$store.commit('IS_LOADING', false)
            self.$swal({
              position: 'top',
              type: 'success',
              title: 'Modification avec succès',
              text: 'La modification a bien été apportée',
              showConfirmButton: false,
              timer: 3000
            })
            this.clearFormProduit()
            this.$root.$emit('bv::toggle::collapse', 'collapse-produit')
            this.$bvModal.hide('modal-modify-produit')
            this.getFamilleProduit()
            this.getProduitsToConfigure()
          })
          .catch(function(error) {
            self.$store.commit('IS_LOADING', false)
            self.$swal({
              position: 'top',
              type: 'error',
              title: 'Attention !!',
              text: 'Une erreur est survenue lors de la modification du produit, si le problème persiste merci de faire un ticket au support DOSI',
              showConfirmButton: false,
              timer: 5000
            })
          })
      }
    },
  }
}
</script>
<style type="text/css">
  .with-index .list-group-item {
    padding: 0;
  }
  .with-index .list-group-item .index, .with-index .list-group-item .body {
    display: inline-block;
    padding: 0.5rem 1rem;
  }
  .with-index .list-group-item .index {
    background-color: #EFEFEF;
    border-right: 1px solid #EAEAEA;
    width: 166px;
  }
  .lh {
    line-height: 37px;
  }
  .list-produit {
    line-height: 30px;
  }
  .list-produit .badge {
    line-height: 1rem;
  }
  table.famille_produit tr td, table.famille_produit tr th {
    border: 1px solid #dbdbdb;
    padding: 0.5rem;
  }
  table.famille_produit tr td:first-child
  {
    border-radius: 5px 0 0 5px;
  }
  table.famille_produit tr td:last-child
  {
    border-radius: 0 5px 5px 0;
  }
  table.famille_produit tr th {
    background-color: #659ac8;
  }
  table.famille_produit tr td.td-gamme {
    background-color: #e4f2ff;
  }
  table.famille_produit tr th.th-famille {
    min-width: 300px;
  }

</style>
